const gtmInitialize = ({ $gtm, $config }) => {
    const { gtmTagId } = $config;
    // force gtm inistialization for all pages
    $gtm.init(gtmTagId);
};
export default gtmInitialize;
